// extracted by mini-css-extract-plugin
export default {"media__badge__container":"MediaBadge_media__badge__container__fY9mE","media__badge__item":"MediaBadge_media__badge__item__LpOyd"};